import { Controller } from "@hotwired/stimulus"

import { buildCountryOptions } from "@shared/lib/country-options"

// Connects to data-controller="contacts--country-options"
//
// The Site Invoicing tab's Country selects (CONEK-8263) list countries exactly
// as React's useCountryOptions does: "CODE - Name" in the user's language
// (i18n-iso-countries official names), sorted by that label — the same
// buildCountryOptions both surfaces call. The server renders an English
// stand-in; on connect this swaps the Ui::SelectComponent's options for the
// React list through its `ui--select:set-options` action, keeping the value.
export default class extends Controller {
  connect() {
    this.apply()
  }

  // Tom Select is built by the inner ui--select controller, which can connect
  // after this one — wait for it (a few frames at most).
  apply(attempt = 0) {
    const select = this.element.querySelector("select")
    if (!select) return
    if (!select.tomselect) {
      if (attempt < 20) requestAnimationFrame(() => this.apply(attempt + 1))
      return
    }

    const language = document.documentElement.lang || "en"
    const options = buildCountryOptions(language).map(({ label, value }) => [
      label,
      value,
    ])
    select.closest('[data-controller~="ui--select"]').dispatchEvent(
      new CustomEvent("ui--select:set-options", {
        detail: { options, value: select.tomselect.getValue() || null },
      }),
    )
  }
}
